export enum DISCOVERY_CONTENTS_TYPE {
  video = 'video',
  text = 'text'
}